import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { alphabetChars } from '~/utils/alphabet';
export default defineComponent({
  name: 'AlphabeticalSorting',
  props: ['selectedLetter', 'usedChars'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var checkIsDisabled = function checkIsDisabled(letter) {
      var _props$usedChars;
      return !((_props$usedChars = props.usedChars) !== null && _props$usedChars !== void 0 && _props$usedChars.includes(letter));
    };
    var onClickLetter = function onClickLetter(letter) {
      if (checkIsDisabled(letter)) {
        return;
      }
      emit('click-alphabetical-sorting', letter);
    };
    return {
      alphabet: alphabetChars,
      checkIsDisabled: checkIsDisabled,
      onClickLetter: onClickLetter
    };
  }
});